import { render, staticRenderFns } from "./CheckboxCompetencyDropdown.vue?vue&type=template&id=4252c516&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./CheckboxCompetencyDropdown.vue?vue&type=script&lang=js&"
export * from "./CheckboxCompetencyDropdown.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxCompetencyDropdown.vue?vue&type=style&index=0&id=4252c516&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252c516",
  null
  
)

export default component.exports